// extracted by mini-css-extract-plugin
module.exports = {"description":"PropertiesState_description__1dJfG"};